import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/app/components/base/base.component';
import { VcsService } from '@wms/app/vcs/services/vcs.service';
import { DeploymentService } from '../../deployment.service';
import {
  WmsDialogBodyComponent,

  WmsDialogFooterComponent,
  WmsDialogHeaderComponent
} from "@wms/components";

@Component({
  selector: 'wms-push-changes-dialog',
  standalone: true,
  imports: [
    CommonModule,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
  ],
  templateUrl: './wms-push-changes-dialog.component.html',
  styleUrls: ['./wms-push-changes-dialog.component.less']
})
export class WmsPushChangesDialogComponent extends BaseComponent {
  @Input() vcsAction: string
  public vcsService: VcsService;
  public deploymentService: DeploymentService

  constructor() {
    super();
    this.vcsService = inject(VcsService);
    this.deploymentService = inject(DeploymentService)
  }

  openPushDialogWithCallback() {
    this.vcsService.closeDialogWithId('vcsSyncDialog')
    if (this.vcsService.vcsAction === 'push') {
      this.vcsService.openPushProjectDialog(this.deploymentService.triggerDeployment.bind(this.deploymentService))
    }
  }
}
